import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import AgoraRTC, { AgoraRTCProvider } from "agora-rtc-react";


////////////// Redux //////////////
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './redux/store';
////////////// Redux //////////////


import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';


// AgoraRTC.setLogLevel(/* DEBUG */ 0);
AgoraRTC.setLogLevel(0);
const client = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });

// Create a client
const queryClient = new QueryClient();


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <QueryClientProvider client={queryClient}>
          <AgoraRTCProvider client={client}>
            <App />
          </AgoraRTCProvider>
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);


